import React, { useEffect, useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { TableBox, SearchFilter, Paging } from '../../components';
import { usePagination, useFilter } from '../../hooks';
import { SnackbarContext } from '../../contexts';
import Button from '@mui/material/Button';
import Handler from '../../Handler';
import API from '../../api';

export const MethodologyListPage = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { updateSnackbar } = useContext(SnackbarContext);
  const [list, setList] = useState(null);
  const [header, setHeader] = useState([
    {
      key: 'seq',
      align: 'center',
      text: 'No',
      style: {
        minWidth: 20,
      },
    },
    {
      key: 'adminId',
      align: 'center',
      text: '작성자',
      style: {
        minWidth: 80,
      },
    },
    {
      key: 'isView',
      align: 'center',
      text: '공개여부',
      style: {
        minWidth: 60,
      },
      render: (value) => {
        return value ? '공개' : '비공개';
      },
    },
    {
      key: 'status',
      align: 'center',
      text: '승인여부',
      style: {
        minWidth: 60,
      },
      render: (value) => {
        return value ? '승인' : '미승인';
      },
    },
    {
      key: 'standard',
      align: 'center',
      text: '방법론 기준',
      style: {
        minWidth: 70,
      },
      render: (value) => {
        return Handler.ENUM.METHODOLOGY.STANDARD(value);
      }
    },
    {
      key: 'id',
      align: 'center',
      text: '방법론 고유번호',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'title',
      align: 'center',
      text: '방법론명',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'version',
      align: 'center',
      text: '버전',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'startDate',
      align: 'center',
      text: '유효기간 시작일',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return Handler.dbDateToYYYYMMDD(value);
      },
    },
    {
      key: 'createdAt',
      align: 'center',
      text: '생성일',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return Handler.getYYYYMMDDByUnix(value);
      },
    },
  ]);

  const [filter, onFilterChange, setFiler] = useFilter([
    {
      key: 'searchType',
      type: 'select',
      label: '검색 종류',
      value: 'Title',
      menus: [
        {
          value: 'Title',
          label: '방법론명',
        },
        {
          value: 'Id',
          label: '방법론 고유번호',
        },
      ],
    },
    {
      key: 'searchValue',
      type: 'input',
      label: '검색 값',
      value: '',
      inputType: 'text',
    },
  ]);
  const [page, totalPage, totalCount, onPageChange, setPage, setTotalPage, setTotalCount] = usePagination(0, 10);
  const params = new URLSearchParams(location.search);

  const tableCallback = (type, index) => {
    console.log('tableCallback type', type);
    console.log('tableCallback index', index);
  };

  const tableRowClick = (index) => {
    console.log('tableRowClick index', index);
    let target_seq = list[index].seq;
    history.push('/methodology/detail/' + target_seq);
  };

  const onSearch = (body) => {
    console.log('onSearch', body);
    requestNewList(0);
  };

  useEffect(() => {
    requestNewList();
    history.push(`?page=${page}`);
  }, [page]);

  useEffect(() => {
    const page = parseInt(params.get('page') || '0', 10);
    setPage(page);
  }, []);

  const requestNewList = (init_page) => {
    let body = Handler.filterToBody(filter);
    console.log('page body', body);
    API.Methodology.Get({
      ...body,
      page: init_page ? init_page : page,
      size: Handler.VARIABLES.PAGE_LIMIT,
    }).then(
      (res) => {
        console.log('res', res);
        let result = res.data;
        setList(result.content);
        setTotalPage(result.totalPages);
      },
      (err) => {
        console.log('err', err);
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      },
    );
  };

  const requsetAdd = () => {
    console.log('requsetAdd');
    history.push('/methodology/add');
  };

  console.log('list', list);

  return (
    <article className='basic-page'>
      <section className='content-header__container'>
        <header>
          <h3>방법론 목록</h3>
        </header>
        <div className='button__box'>
          <Button variant='contained' onClick={requsetAdd}>
            추가
          </Button>
        </div>
      </section>
      <section className='filter__container'>
        <SearchFilter data={filter} onChange={onFilterChange} onSearch={onSearch}></SearchFilter>
      </section>
      <section className='table__container'>
        <TableBox data={list} header={header} rowClick={tableRowClick} callback={tableCallback}></TableBox>
      </section>
      <section className='paging__container'>
        <Paging page={page} totalPage={totalPage} onChange={onPageChange}></Paging>
      </section>
    </article>
  );
};
